/* eslint-disable max-len */
import 'react';

const MoveSearchSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_7_1600" style={{'maskType': 'luminance'}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="white" />
            </mask>
            <g mask="url(#mask0_7_1600)">
                <circle cx="11.605" cy="11.3222" r="6" transform="rotate(-45 11.605 11.3222)" stroke="#5C6473" strokeWidth="1.5" />
                <path d="M16.3234 15.4042L18.869 17.9498" stroke="#5C6473" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>

    );
};

export default MoveSearchSvg;
